var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultBlobStorage, defaultPublicBlobStorage } from "./constants";
export var appConfigs = createDefaultConfig();
export function mergeAppConfigs(newConfig) {
    appConfigs.storage = __assign(__assign({}, appConfigs.storage), newConfig.storage);
    appConfigs.contacts = __assign(__assign({}, appConfigs.contacts), newConfig.contacts);
    appConfigs.branding = __assign(__assign({}, appConfigs.branding), newConfig.branding);
}
function createDefaultConfig() {
    var messenger = "https://m.me/hashimukhfdn";
    return {
        storage: {
            root: defaultBlobStorage,
            public: defaultPublicBlobStorage,
        },
        branding: {
            logoLightUrl: defaultPublicBlobStorage + "company_logo_compact.svg",
            logoDarkUrl: defaultPublicBlobStorage + "company_logo_compact_dark.svg",
        },
        contacts: {
            email: "hello@hashimukh.org",
            number: "+880 1813-182049",
            facebook: "https://www.facebook.com/hashimukhfdn",
            facebookShort: "https://fb.me/hashimukhfdn",
            messenger: messenger,
            messengerShort: messenger,
            defaultMessage: messenger,
        }
    };
}
//# sourceMappingURL=appConfigs.js.map